import {CtaBannerSmall} from 'shells/cta-banner/cta-banner-small';
import {CogRegularIcon} from 'shells/icon/svg/cog-regular-icon';

type Props = {
    isAdmin: boolean;
    onSettingsClick: () => void;
};

export function ResearchCta(props: Props) {
    return (
        <CtaBannerSmall
            onCtaClick={props.onSettingsClick}
            ctaMessageType='subtle'
            icon={CogRegularIcon}
            ctaText={props.isAdmin ? 'Set up' : undefined}
            text={
                props.isAdmin
                    ? 'Answer two questions about your business to see lead fit'
                    : 'Ask your admin to set up lead research to see lead fit.'
            }
        />
    );
}
